function matchesQuery(values, query) {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  return !normalizedQuery || values.some((value) =>
    String(value ?? '').toLocaleLowerCase().includes(normalizedQuery)
  );
}

function normalizeLocation(value) {
  return String(value ?? '').trim().toLocaleLowerCase();
}

function locationCandidates(...values) {
  return [...values]
    .flatMap((value) => {
      if (value == null) return [];
      if (Array.isArray(value)) return value;
      return [value];
    })
    .map((value) => normalizeLocation(value))
    .filter(Boolean);
}

function matchesBuyerLocation(offer, { buyerCity, buyerBarangay, ownerProfiles = {}, role }) {
  if (role !== 'buyer') return true;

  const buyerCityValues = locationCandidates(buyerCity);
  const buyerBarangayValues = locationCandidates(buyerBarangay);
  if (buyerBarangayValues.length === 0) return false;

  const travelerProfile = ownerProfiles[offer.owner_id] || {};
  const travelerCityValues = locationCandidates(
    travelerProfile.public_city,
    travelerProfile.city,
    travelerProfile.municipality,
    travelerProfile.municipality_name,
    travelerProfile.location_city,
    travelerProfile.public_city_name
  );
  const travelerBarangayValues = locationCandidates(
    travelerProfile.public_barangay_code,
    travelerProfile.barangay_code,
    travelerProfile.public_barangay,
    travelerProfile.barangay,
    travelerProfile.public_barangay_name,
    travelerProfile.barangay_name,
    travelerProfile.public_barangay_code_name
  );

  if (!travelerBarangayValues.length) return false;

  const barangayMatch = buyerBarangayValues.some((value) => travelerBarangayValues.includes(value));
  if (!barangayMatch) return false;

  // Some older or partially migrated records have the PSGC barangay code but a blank city.
  // In that case, the barangay match is the reliable identifier for same-area locality.
  if (buyerCityValues.length === 0 || travelerCityValues.length === 0) return true;

  const cityMatch = buyerCityValues.some((value) => travelerCityValues.includes(value));
  return cityMatch;
}

export function filterTrips(trips, { query = '', date = '' } = {}) {
  return trips.filter((trip) =>
    matchesQuery([trip.origin, trip.destination, ...(trip.tags ?? [])], query) &&
    (!date || trip.travel_date === date)
  );
}

export function filterOffers(
  offers,
  { query = '', date = '', buyerCity = '', buyerBarangay = '', ownerProfiles = {}, role = '' } = {}
) {
  return offers.filter((offer) =>
    matchesQuery([offer.store_name, offer.public_area], query) &&
    (!date || offer.planned_date === date) &&
    matchesBuyerLocation(offer, { buyerCity, buyerBarangay, ownerProfiles, role })
  );
}

export function filterOrders(orders, { query = '', status = '' } = {}) {
  return orders.filter((order) =>
    matchesQuery([order.item_name, order.delivery_city], query) &&
    (!status || order.status === status)
  );
}
